import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../../../theme';

export const useAdminConsoleListStyles = createStyles(({ token }) => ({
  darkThemeTag: {
    backgroundColor: ThemeColors.COLOR_GREY_DARK3,
    border: `1px solid ${ThemeColors.COLOR_GREY_DARK5}`,
    fontFamily: ThemeFont.FONT_CONDENSED,
    fontWeight: 'normal',
    color: ThemeColors.COLOR_GREY_BLUISH8,
    fontSize: token.fontSizeSM,
    borderRadius: token.borderRadiusSM,

    '.ant-tag-close-icon': {
      color: ThemeColors.COLOR_GREY_BLUISH7_4,
      marginLeft: ThemeSpaces.SPACE_SM,

      '&:hover': {
        color: ThemeColors.COLOR_GREY_BLUISH7_4,
      },
    },
  },
}));
